var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMic20 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.25,
  d: "M10 15.104a5.47 5.47 0 0 0 5.014-3.281M10 15.104a5.47 5.47 0 0 1-5.014-3.281M10 15.104v1.64m0-4.01a3.1 3.1 0 0 1-3.099-3.099v-3.28a3.099 3.099 0 1 1 6.198 0v3.28a3.1 3.1 0 0 1-3.099 3.1"
})));
export default SvgMic20;